module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-f7b3936f89fefb1ff675ec20a5b81750.png";